import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postStreamItem } from '../../../api/items';

import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import { mergeItemWithUserData } from '../../../utils/items';

import { POST_STREAM_ITEM_METHODS } from '../../../components/Items/constants/postStreamItemMethods';

export const changeItemRebuzzable = createAsyncThunk(
  'items/changeItemRebuzzable',
  async ({ path, params }, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [itemResponse, itemUserDataResponse] = await postStreamItem(
        {
          path,
          params: {
            method: POST_STREAM_ITEM_METHODS.rebuzzable,
            rebuzzable: params?.rebuzzable,
          },
        },
        {
          cancelToken: source.token,
        },
      );

      return mergeItemWithUserData(itemResponse, itemUserDataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const changeItemRebuzzableExtraReducers = builder => {
  builder
    .addCase(changeItemRebuzzable.pending, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);
      checkAndSetLoadingWithId(
        state.items.item.actions.update.request,
        action,
        itemCIDKey,
      );
    })
    .addCase(changeItemRebuzzable.fulfilled, (state, action) => {
      const { payload } = action;
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);
      onMatchedRequest(
        state.items.item.actions.update.request[itemCIDKey],
        action,
        () => {
          state.items.item.byId[itemCIDKey] = payload;
          if (!state.items.item.allIds.includes(itemCIDKey)) {
            state.items.item.allIds.push(itemCIDKey);
          }
        },
      );
    })
    .addCase(changeItemRebuzzable.rejected, (state, action) => {
      const itemCIDKey = generateItemCIDKey(action.meta.arg.path);
      handleRequestRejection(
        state.items.item.actions.update.request[itemCIDKey],
        action,
      );
    });
};
